export default __webpack_public_path__ + "static/media/megane-rs-gallery-2.22e53b74.jpg";